module.exports = __webpack_public_path__ + "img/40_38_078_050.8efddd3e.jpg";